import axios from 'axios';
import { publicAPI } from 'services/api/apiUrl';

export const getDeliveryZone = () =>
  axios({
    method: 'get',
    url: `${publicAPI}/deliveryzone`,
  });
